const getters = {
  userToken: state => state.user.userToken,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  user_id: state => state.user.user_id,
  waybill_api_permission: state => state.user.waybill_api_permission,
  cbec_permission: state => state.user.cbec_permission,
  order_sn_permission: state => state.user.order_sn_permission,
  apiUrl: state => state.app.apiUrl,
	appId: state => state.app.appId,
	appKey: state => state.app.appKey,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js